import { render, staticRenderFns } from "./ssh.vue?vue&type=template&id=2f4ed5f2&"
import script from "./ssh.vue?vue&type=script&lang=js&"
export * from "./ssh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports